import React, {useState, useEffect} from "react";
import { GetBlogByIdData, GetCategoriesBlogData} from "../../../lib/data";
import EditBlogsUi from "../../../ui/blogsUi/editBlogsUi";
import { useParams } from "react-router-dom";
import i18n from "../../../lib/i18n";

export default function EditBlogs () {

    const {blogId} = useParams();
    const [categoriesBlogData, setCategoriesBlogData] = useState([]);
    const [blogData, setBlogData] = useState({});
    const t = i18n.t.bind(i18n); 

    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        const categoriesBlogsData = await GetCategoriesBlogData();
        const blogsData = await GetBlogByIdData(blogId);
        setCategoriesBlogData([]);
        setBlogData({});
        setBlogData(blogsData);
        categoriesBlogsData.data.map((e) => setCategoriesBlogData((prev) => [...prev, e]));
    };

    const search = async (param) => {
        const params = [ {"name": param} ];
        if(param){
            const categoriesBlogsDataFilter = await GetCategoriesBlogData(1,params);
            setCategoriesBlogData([]);
            categoriesBlogsDataFilter.data.map((e) => setCategoriesBlogData((prev) => [...prev, e]));
        }
    };

    return(
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4"> {t("edit_page_title.blog")}</h1>
                <EditBlogsUi search={search} blogData={blogData} categoriesBlogData={categoriesBlogData} />
            </div>
        </div>
    );
};